export default "__VITE_ASSET__DsP9t0_a__"